import styles from '../../styles/modules/modal/Modal.module.scss';

import Icon from '../icon/Icon';
import ModalTimer from './ModalTimer';
import AuthButtons from '../auth/AuthButtons';

import caseImg from '../../assets/images/case.webp';

const Modal = ({ onClose }) => {
	return (
		<div className={styles.modal}>
			<div className={styles.inner}>
				<p className={styles.title}>твой подарок</p>
				<p className={styles.subtitle}>Твоё первое открытие готово, авторизируйся и забери его!</p>
				<div className={styles.image}>
					<img src={caseImg} alt='' />

					<div className={styles.price}>200 ₽</div>
				</div>

				<ModalTimer />

				<AuthButtons
					text='войти'
					className={styles.authButtons}
					classNameButton={styles.authButton}
					classNameTitle={styles.authButtonsTitle}
				/>

				<a className={styles.link} href='https://epicloot.am/'>
					Войти без авторизации и потерять 🎁
				</a>
			</div>

			<div className={styles.close} onClick={onClose}>
				<span>Закрыть</span>
				<Icon name='close' />
			</div>
		</div>
	);
};

export default Modal;
